import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {postUserPreferences} from "../actions/post_user_preferences";
import {IUserPreferences, IUserPreferencesFilters} from "../interfaces/IUserPreferences";
import {transformUserPreferencesForSave} from "../utils/transform_user_preferences";

interface IOptions {
    debounce: boolean;
}

export const useUserSearchPreferences = (options?: IOptions) => {
    const dispatch = useDispatch();
    const userPreferences = useSelector((state: IRPStore) => state.user.preferences);

    const saveUserPreferences = useCallback(
        (preferences: IUserPreferences) => {
            if (JSON.stringify(preferences) === JSON.stringify(userPreferences)) {
                // Preferences are the same, there is no need to be saved again.
                return Promise.resolve(true);
            }

            return dispatch(postUserPreferences(transformUserPreferencesForSave(preferences), options?.debounce));
        },
        [dispatch]
    );

    const updateUserPreferences = useCallback(
        (filters: IUserPreferencesFilters) => {
            const modifiedFilters = {...(userPreferences?.data?.filters || {}), ...filters};
            return dispatch(postUserPreferences(transformUserPreferencesForSave({filters: modifiedFilters}), options?.debounce));
        },
        [dispatch, userPreferences]
    );

    return {
        saveUserPreferences,
        updateUserPreferences,
        userPreferences
    };
};
import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {postUserPreferences} from "../actions/post_user_preferences";
import {IUserPreferences, IUserPreferencesFilters} from "../interfaces/IUserPreferences";
import {transformUserPreferencesForSave} from "../utils/transform_user_preferences";

interface IOptions {
    debounce: boolean;
}

export const useUserSearchPreferences = (options?: IOptions) => {
    const dispatch = useDispatch();
    const userPreferences = useSelector((state: IRPStore) => state.user.preferences);

    const saveUserPreferences = useCallback(
        (preferences: IUserPreferences) => {
            if (JSON.stringify(preferences) === JSON.stringify(userPreferences)) {
                // Preferences are the same, there is no need to be saved again.
                return Promise.resolve(true);
            }

            return dispatch(postUserPreferences(transformUserPreferencesForSave(preferences), options?.debounce));
        },
        [dispatch]
    );

    const updateUserPreferences = useCallback(
        (filters: IUserPreferencesFilters) => {
            const modifiedFilters = {...(userPreferences?.data?.filters || {}), ...filters};
            return dispatch(postUserPreferences(transformUserPreferencesForSave({filters: modifiedFilters}), options?.debounce));
        },
        [dispatch, userPreferences]
    );

    return {
        saveUserPreferences,
        updateUserPreferences,
        userPreferences
    };
};
